export const certifications = [
  {
    logo: "/assets/images/Logos/COMPTIA.png",
    name: "CompTIA Network+ (N10-007)",
    issuer: "CompTIA",
    issued: "Nov 2020",
    expires: "Nov 2023",
    credentialId: "",
    accent: "cyan",
    skills: [
    //   "Networking Fundamentals",
    //   "Routing and Switching",
    //   "Network Security",
    //   "Troubleshooting",
    ],
    certificateImage: "/assets/images/Logos/NET.png",
    certificateLink: "",
  },
  {
    logo: "/assets/images/Logos/COMPTIA.png",
    name: "CompTIA Security+ (SY0-501)",
    issuer: "CompTIA",
    issued: "Feb 2021",
    expires: "Feb 2024",
    credentialId: "",
    accent: "green",
    skills: [
    //   "Threat Detection",
    //   "Risk Management",
    //   "Cryptography",
    //   "Security Operations",
    ],
    certificateImage: "/assets/images/Logos/SEC.png",
    certificateLink: "",
  },
  {
    logo: "/assets/images/Logos/LTU.png",
    name: "Cyber Technologies",
    issuer: "La Trobe University (CSE)",
    issued: "Oct 2022",
    expires: "Lifetime",
    credentialId: "",
    accent: "blue",
    skills: [
    //   "Cybersecurity Fundamentals",
    //   "Secure Systems",
    //   "Threat Analysis",
    ],
    certificateImage: "/assets/images/Logos/LTU.png",
    certificateLink: "",
  },
  {
    logo: "/assets/images/Logos/EC.png",
    name: "Master Wireshark 3 in 5 Days",
    issuer: "EC-Council",
    issued: "Aug 2023",
    expires: "Lifetime",
    // credentialId: "239074",
    accent: "indigo",
    skills: [
    //   "Packet Analysis",
    //   "Network Troubleshooting",
    //   "Traffic Inspection",
    ],
    certificateImage: "/assets/images/Logos/EC.png",
    certificateLink: "",
  },
  {
    logo: "/assets/images/Logos/BDNOG.png",
    name: "IPv6 & Routing Best Practices",
    issuer: "BDNOG",
    issued: "May 2026",
    expires: "Lifetime",
    // credentialId: "239074",
    accent: "red",
    skills: [
    //   "Packet Analysis",
    //   "Network Troubleshooting",
    //   "Traffic Inspection",
    ],
    certificateImage: "/assets/images/Logos/IPv6.png",
    certificateLink: "",
  },
];